var Geometry = require("./basicGeometry.js");
var jsts = require("jsts");

/**
 * Attach some extra functions so that the geometry objects can be converted to and from JSTS primitives.
 */

Geometry.convertFromJsts = function (obj) {
    switch(obj.constructor) {
        case jsts.geom.Polygon:
            if(!obj.holes.length)
                return new Geometry.Polygon().fromJsts(obj);
            else
                return new Geometry.ComplexPolygon().fromJsts(obj);
        case jsts.geom.MultiPolygon:
            return new Geometry.MultiPolygon().fromJsts(obj);
        default:
            console.throw("unsupported type");
            break;
    }
};

Geometry.BoundingBox.prototype.toJsts = function() {
    var result = new jsts.geom.Envelope();
    result.init(this.getXMin(), this.getXMax(), this.getYMin(), this.getYMax());
    return result;
};

Geometry.Coord.prototype.toJsts = function() {
    var result = new jsts.geom.Coordinate(this.x, this.y);
    return result;
};

Geometry.Trace.prototype.toJstsPolygon = function(width, quadrantSegments) {
    var factory = new jsts.geom.GeometryFactory();

    var jstsPoints = [];

    for (var i = 0; i < this.points.length; i++) {
        var point = this.points[i];
        jstsPoints.push(point.toJsts());
    }

    var geom;
    if (this.points.length > 1) {
        geom = factory.createLineString(jstsPoints);
    } else {
        geom = jstsPoints[0];
    }

    var jstsPoly = geom.buffer(width/2, quadrantSegments);

    return jstsPoly;
};


Geometry.Trace.prototype.toPolygon = function(width) {
    var poly = new Geometry.Polygon();
    poly.fromJsts(this.toJstsPolygon(width));
    return poly;
};

Geometry.Trace.prototype.toOutlineGeometry = function(width, precision) {
    return Geometry.convertFromJsts(this.toJstsPolygon(width, precision));
};


var oldComplexPolyTaintCache = Geometry.ComplexPolygon.prototype.taintCache;
Geometry.ComplexPolygon.prototype.taintCache = function() {
    oldComplexPolyTaintCache.call(this);
    this._jstsPoly = null;
};

Geometry.ComplexPolygon.prototype._toJsts = function() {
    var i, point;
    var factory = new jsts.geom.GeometryFactory();

    var ring = [];
    for (i = 0; i < this.points.length; i++) {
        point = this.points[i];
        ring.push(new jsts.geom.Coordinate(point.x,point.y));
    }
    ring.push(ring[0]);

    var shell = factory.createLinearRing(ring);

    var holes = [];
    for (var j = 0; j < this.holes.length; j++) {
        var hole = this.holes[j];

        ring = [];
        for (i = 0; i < hole.length; i++) {
            point = hole[i];
            ring.push(new jsts.geom.Coordinate(point.x,point.y));
        }
        ring.push(ring[0]);

        holes.push(factory.createLinearRing(ring));
    }

    var jsts_poly = factory.createPolygon(shell,holes);

    return jsts_poly;
};

Geometry.ComplexPolygon.prototype.toJsts = function() {
    if(!this._jstsPoly) this._jstsPoly = this._toJsts();
    return this._jstsPoly;
};

Geometry.ComplexPolygon.prototype.fromJsts = function(jsts) {
    this.taintCache();

    var i, point;
    this.points = [];

    var ring = jsts.getExteriorRing().getCoordinates();
    for (i = 0; i < ring.length-1; i++) {
        point = ring[i];
        this.points.push(new Geometry.Coord(point.x,point.y));
    }

    for (var j=0; j<jsts.getNumInteriorRing();j++) {
        ring = jsts.getInteriorRingN(j).getCoordinates();

        var hole = [];
        for (i = 0; i < ring.length-1; i++) {
            point = ring[i];
            hole.push(new Geometry.Coord(point.x,point.y));
        }
        this.holes.push(hole);
    }
    return this;
};

Geometry.Polygon.prototype.fromJsts = function(jstsPoly) {
    this.taintCache();
    var ring = jstsPoly.getExteriorRing().getCoordinates();
    for (var i = 0; i < ring.length-1; i++) {
        var point = ring[i];
        this.points.push(new Geometry.Coord(point.x,point.y));
    }
    return this;
};

Geometry.Polygon.prototype.fromJstsLinRing = function(jstsLinearRing) {
    this.taintCache();
    this.points = [];
    var ring = jstsLinearRing.getCoordinates();
    for (var i = 0; i < ring.length-1; i++) {
        var point = ring[i];
        this.points.push(new Geometry.Coord(point.x,point.y));
    }
    return this;
};

// Geometry.Polygon.prototype.buffer = function(dist, quadrantSegments) {
//     var jstsPoly = null;
//     if(quadrantSegments)
//         jstsPoly = this.toJsts().buffer(dist, quadrantSegments);
//     else
//         jstsPoly = this.toJsts().buffer(dist);
//     return Geometry.convertFromJsts(jstsPoly);
// };

// Geometry.Polygon.prototype.intersection = function(other) {
//     var jstsPoly = this.toJsts().intersection(other.toJsts());
//     return Geometry.convertFromJsts(jstsPoly);
// };

// Geometry.Polygon.prototype.difference = function(other) {
//     var jstsPoly = this.toJsts().difference(other.toJsts());
//     return Geometry.convertFromJsts(jstsPoly);
// };

var oldPolyTaintCache = Geometry.Polygon.prototype.taintCache;
Geometry.Polygon.prototype.taintCache = function() {
    oldPolyTaintCache.call(this);
    this._jstsPoly = null;
};

Geometry.Polygon.prototype._toJsts = function() {
    if(this.points.length <= 2) return;
    var factory = new jsts.geom.GeometryFactory();

    var linearRing = this.toJstsRing();
    var polygon = factory.createPolygon(linearRing);

    if(!this.selfIntersects() || polygon.isValid())
        return polygon;

    //http://stackoverflow.com/questions/36118883/using-jsts-buffer-to-identify-a-self-intersecting-polygon
    var lineString = factory.createLineString(linearRing.getCoordinateSequence());
    // unioning the linestring with the point makes any self intersections explicit.
    var point = factory.createPoint(lineString.getCoordinateN(0));
    var toAdd = lineString.union(point);

    var polygonizer = new jsts.operation.polygonize.Polygonizer();
    polygonizer.add(toAdd);
    var polygons = polygonizer.getPolygons().toArray();

    switch (polygons.length) {
        case 0:
            return null;
        case 1:
            return polygons[0];
        default:
            return new jsts.geom.MultiPolygon(polygons, factory);
    }
    // console.assert(jstsPolygon.isValid());
};

Geometry.Polygon.prototype.toJsts = function() {
    if(!this._jstsPoly) this._jstsPoly = this._toJsts();
    return this._jstsPoly;
};


Geometry.Polygon.prototype.toJstsRing = function() {
    var factory = new jsts.geom.GeometryFactory();
    var ring = [];
    for (var i = 0; i < this.points.length; i++) {
        var point = this.points[i];
        ring.push(new jsts.geom.Coordinate(point.x,point.y));
    }
    ring.push(ring[0]);
    var jstsRing = factory.createLinearRing(ring);
    // console.assert(jstsRing.isValid());
    return jstsRing;
};

Geometry.MultiPolygon.prototype.toJsts = function() {
    var factory = new jsts.geom.GeometryFactory();
    var jstsPolys = this.polygons.map(function(p) { return p.toJsts(); });
    var jstsMultiPoly = new jsts.geom.MultiPolygon(jstsPolys, factory);
    return jstsMultiPoly;
};

Geometry.MultiPolygon.prototype.fromJsts = function(jsts) {
    var self = this;
    this.polygons = [];
    jsts.geometries.forEach(function(jstsPoly) {
        var poly = new Geometry.Polygon();
        poly.fromJsts(jstsPoly);
        self.polygons.push(poly);
    });
    return this;
};

// Geometry.MultiPolygon.prototype.difference = function(other) {
//     var jstsPoly = this.toJsts().difference(other.toJsts());
//     return Geometry.convertFromJsts(jstsPoly);
// };

// Geometry.MultiPolygon.prototype.intersection = function(other) {
//     var jstsPoly = this.toJsts().intersection(other.toJsts());
//     return Geometry.convertFromJsts(jstsPoly);
// };

/**
 * Created with JetBrains RubyMine.
 * User: kbruneel
 * Date: 1/1/13
 * Time: 5:24 PM
 * To change this template use File | Settings | File Templates.
 */

Geometry.jstsPolyToSVG = function(poly) {

    var d = "";
    var rings = [];

    rings.push(poly.getExteriorRing());

    for (var i=0; i<poly.getNumInteriorRing();i++) {
        rings.push(poly.getInteriorRingN(i));
    }

    for (var r = 0; r < rings.length; r++) {
        var ring = rings[r];
        var ringCoords = ring.getCoordinates();

        for (i = 0; i < ringCoords.length-1; i++) {
            var point = ringCoords[i];

            if (i === 0) {
                d += "M " + point.x + " " + point.y + " ";
            } else {
                d += "L " + point.x + " " + point.y + " ";
            }
        }
        d += "Z";
    }

    var path = $('<path/>');
    path.attr('d', d);

    return path;
};
